import type * as stylex from '@stylexjs/stylex';
import { createLink } from '@tanstack/react-router';

import { LinkIconButton, type LinkIconButtonProps } from '@/libs/serenity-ui';

// createLink somehow affects the style property, so we need to use a custom property to pass the style property to the component.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const RouterIconButtonLink = createLink(({ className, ...props }: Omit<LinkIconButtonProps, 'style'> & { className?: string, _style?: stylex.StyleXStyles }) => <LinkIconButton {...props} style={props._style} />);
